import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Truncate from 'react-truncate';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import InformationIcon from '../utility/InformationIcon';
import LearnMoreLink from '../career-path/utility/LearnMoreLink';
import { modalOpen_GTM } from '../../gtm/datalayers/utilDataLayers.json';
import Favorite from '../utility/Favorite';
import SunIcon from '../utility/SunIcon.jsx';

class DashboardPathways extends Component {
  careerCard(career, image, degree) {
    const { tenant, location, setParentOnClick } = this.props;
    const cardPrimaryBorderBottom = {
      color: `${tenant.secondary}`,
    };
    const pathAddonPrimary = {
      background: `${tenant.secondary}`,
    };

    return (
      <div className="career-card yellow-degree-path-added">
        <div className="career-card-inner-container yellow-degree-path-added">
          <div className="career-card-content">
            <img
              className="card-image modify-image-border"
              src={image}
              alt="placeholder career"
              width="800"
              height="400"
            />
            <div className="career-card-favorite-container">
              <Favorite
                careerId={career?.id}
                career={career}
                careerName={career?.titleEn}
                location={this.props.location}
                userProfileFavorites={this.props.userProfileFavorites}
              />
            </div>
            <div
              className="button-career-text-container yellow-degree-path-added"
              style={cardPrimaryBorderBottom}
            >
              <div>
                <p className="career-text">
                  <Truncate lines={2} style={{ width: '100%' }} ellipsis="...">
                    {career?.titleEn}
                  </Truncate>
                </p>
                <Link
                  to={{
                    pathname: this.props.location.pathname,
                    search: this.props.location.pathname.includes(
                      'user-profile'
                    )
                      ? `?userId=${this.props.userProfile?.id}&tenantId=${
                          this.props.userProfile?.tenantId
                        }&career=${encodeURIComponent(career?.titleEn)}`
                      : `career=${encodeURIComponent(career?.titleEn)}`,
                    state: this.props.location.pathname.includes('user-profile')
                      ? {
                          userId: this.props.userProfile?.id,
                          tenantId: this.props.userProfile?.tenantId,
                        }
                      : null,
                  }}
                  aria-label={`Learn more about ${career?.titleEn} career`}
                >
                  <LearnMoreLink
                    tenant={tenant}
                    data-cy="learn-more-link"
                    primary={tenant.primary}
                    component={career?.titleEn}
                    modalImage={image}
                    ariaLabel={`Learn more about ${career?.titleEn} career`}
                  />
                </Link>
                {career?.careerOutlook ? (
                  <SunIcon
                    marginRight="5px"
                    setParentOnClick={setParentOnClick}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
        {!isEmpty(degree) ? (
          <div className="path-chosen-addon-container" style={pathAddonPrimary}>
            <p className="degree-title-text" data-cy="yellow-path-added">
              <Truncate lines={1} ellipsis="...">
                {degree?.titleEn}
              </Truncate>
            </p>
            <Link
              to={{
                pathname: location.pathname,
                search: location.pathname.includes('user-profile')
                  ? `?userId=${this.props.userProfile?.id}&tenantId=${
                      this.props.userProfile?.tenantId
                    }&degree=${encodeURIComponent(degree?.titleEn)} degreeId ${
                      degree?.id
                    }`
                  : `degree=${encodeURIComponent(degree?.titleEn)} degreeId ${
                      degree?.id
                    }`,
                state: location.pathname.includes('user-profile')
                  ? {
                      userId: this.props.userProfile?.id,
                      tenantId: this.props.userProfile?.tenantId,
                    }
                  : null,
              }}
              aria-label={`click to open more info about ${degree?.titleEn} degree`}
            >
              <div className="learn-more">
                <InformationIcon
                  color={tenant.primary}
                  gtmObj={modalOpen_GTM}
                  section={career?.titleEn}
                  text="information"
                  modalImage={image}
                  ariaLabel={`click to open more info about ${degree?.titleEn} degree`}
                  tabIndex="-1"
                />
              </div>
            </Link>
          </div>
        ) : (
          <div className="path-chosen-addon-container" style={pathAddonPrimary}>
            <p className="degree-title-text">No degree paired</p>
          </div>
        )}
      </div>
    );
  }

  render() {
    const { userData } = this.props.onboarding;

    const getImageIfNull = (index) => {
      // Adding this if statement for our initial test users
      // If a user hasn't played the game, but has data entered in our DB
      // We will need to add images based on the logged in user
      if (!this.props.userProfile?.careerGameResults[index]) {
        return userData.careerGameResults[index].image;
      }
      if (this.props.userProfile?.careerGameResults[index].image) {
        return this.props.userProfile?.careerGameResults[index].image;
      }
      return this.props.userProfile?.careerGameResults[index].categoryImageUrl1;
    };

    return (
      <div className="pathways">
        {this.careerCard(
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.careerGameResults[0]
            : userData.careerGameResults[0],
          this.props.location.pathname.includes('user-profile')
            ? getImageIfNull(0)
            : userData.careerGameResults[0].image,
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.degreeChoices[1]
            : this.props.onboarding.degreeChoices[1]
        )}
        {this.careerCard(
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.careerGameResults[1]
            : userData.careerGameResults[1],
          this.props.location.pathname.includes('user-profile')
            ? getImageIfNull(1)
            : userData.careerGameResults[1].image,
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.degreeChoices[2]
            : this.props.onboarding.degreeChoices[2]
        )}
        {this.careerCard(
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.careerGameResults[2]
            : userData.careerGameResults[2],
          this.props.location.pathname.includes('user-profile')
            ? getImageIfNull(2)
            : userData.careerGameResults[2].image,
          this.props.location.pathname.includes('user-profile')
            ? this.props.userProfile?.degreeChoices[3]
            : this.props.onboarding.degreeChoices[3]
        )}
      </div>
    );
  }
}

DashboardPathways.propTypes = {
  onboarding: PropTypes.object.isRequired,
  tenant: PropTypes.object.isRequired,
};

export default DashboardPathways;
